import { Rule } from 'antd/lib/form'

import { RichTextCaptureBlock as RichTextCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import { RichTextInput } from '@/components/form-components/RichTextInput'

type Props = {
  block: RichTextCaptureBlockType
  rules: Rule[]
}

export const RichTextCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const { value } = block

  return (
    <CaptureBlockFormItem block={block} initialValue={value} rules={rules}>
      <RichTextInput block={block} />
    </CaptureBlockFormItem>
  )
}
